import { emailRequired, phoneNumber } from "./index";
import {
  DEFAULT_SEQUOIA_EMAIL_PREFIX,
  DEFAULT_SEQUOIA_EMAIL_DOMAIN,
  DEFAULT_SEQUOIA_PHONE_NUMBER,
} from "@covertree/consts";

export const sequoiaEmail = (isBookConversion: boolean) =>
  emailRequired().test(
    "sequoia-email-check",
    "The email you provided cannot be used",
    (value) => {
      if (!isBookConversion) return true;
      const isSequoiaDefaultEmail =
        value.startsWith(DEFAULT_SEQUOIA_EMAIL_PREFIX) &&
        value.endsWith(DEFAULT_SEQUOIA_EMAIL_DOMAIN);
      return !isSequoiaDefaultEmail;
    }
  );

export const sequoiaPhoneNumber = (isBookConversion: boolean) =>
  phoneNumber()
    .required("Phone number is required")
    .test(
      "not-default-phone-sequoia",
      "The phone number you provided cannot be used",
      (value) => {
        if (!isBookConversion) return true;
        return value !== DEFAULT_SEQUOIA_PHONE_NUMBER;
      }
    );
